import { Navigate, Route, Routes, BrowserRouter } from "react-router-dom";
import { Flex, Typography } from "antd";
import MainTemplate from "./components/templates/main/mainTemplate";
import { useAppSelector } from "./util/hooks";

//Views
import Feriado from "./views/feriado";
import ContaBanco from "./views/contaBanco";
import CondicaoGeralSorteio from "./views/condicaoGeral";
import GradePremiacao from "./views/gradePremiacao";
import Banco from "./views/banco";
import CentroCusto from "./views/centroCusto";
import FormaPagamentoRecebimento from "./views/formaPagamentoRecebimento/index";
import PlanoContaFinanceiro from "./views/planoContaFinanceiro/index";
import PlanoContaContabil from "./views/planoContaContabil";
import Usuario from "./views/usuario";
import TipoTaxaImposto from "./views/tipoTaxaImposto";
import FechamentoFinanceiro from "./views/fechamentoFinanceiro";
import ImportacaoVendaConsignatario from "./views/importacaoVendaConsignatario";
import AgendaCompromissoFiscal from "./views/agendaCompromissoFiscal";
import PrestacaoConta from "./views/prestacaoConta";
import TipoSorteio from "./views/tipoSorteio";
import GrupoPlanoContaFinanceiro from "./views/grupoPlanoContaFinanceiro";
import TipoDocumento from "./views/tipoDocumento";
import ComparativoEmpresa from "./views/comparativoEmpresa";
import ComparativoResultadoEmpresa from "./views/comparativoEntreEmpresa";
import LancamentoControleAporte from "./views/lancamentoControleAporte";
import PainelGeral from "./views/painelGeral";
import ResultadoSorteio from "./views/resultadoSorteio";
import Composicao from "./views/composicao";
import PlanoContaFinanceiroResultado from "./views/planoContaFinanceiroResultado";
import LancamentoConsignatario from "./views/lancamentoConsignatario";
import CadastroEdicaoConta from "./views/contaFinanceira/pages/cadastrar";
import PagamentoPage from "./views/contaFinanceira/pages/pagamentos";
import ConfiguracaoImpostoAdicional from "./views/configuracaoImpostoAdicional";
import NotasFiscais from "./views/notasFiscais";
import CategoriaEmpresa from "./views/categoriaEmpresa";
import ConfiguracaoImportacaoVenda from "./views/configuracaoImportacaoVenda";
import Anexos from "./views/anexos";
import RelatorioComparativoEntreEmpresa from "./views/comparativoEntreEmpresa/relatorios";
import GrupoContaBanco from "./views/grupoContaBanco";
import ConsolidadoSaldoBancario from "./views/relatorios/consolidadoSaldoBancario";
import AcessoPageController from "./views/acesso/acessoPageController";
import EmpresaPageController from "./views/empresa/empresaPageController";
import ConsignatarioPageController from "./views/consignatario/consignatarioPageController";
import PessoaPageController from "./views/pessoa/pessoaPageController";
import SorteioPageController from "./views/sorteio/sorteioPageController";
import ContaFinanceiraPageController from "./views/contaFinanceira/contaFinanceiraPageController";
import RateioCentroCustoPageController from "./views/rateioCentroCusto/rateioCentroCustoPageController";
import ConfiguracoesPontoPageController from "./views/configuracoesPonto/configuracoesPontoPageController";
import MovimentacaoFinanceiraRelatorio from "./views/relatorios/movimentacaoFinanceira";
import ContaPagamentoRecebimentoRelatorio from "./views/relatorios/contasPagamentoRecebimento";
import ContaBancariaRelatorio from "./views/relatorios/contaBancaria";
import SaldoConsignatarioRelatorio from "./views/relatorios/saldoConsignatario";
import LancamentosRelatorio from "./views/relatorios/lancamentos";
import CreditosConsignatariosRelatorio from "./views/relatorios/creditosConsignatarios";
import LancamentoBancarioRelatorio from "./views/lancamentoBancario/relatorios/lancamentoBancario";
import LancamentoBancarioPorPlanoContaRelatorio from "./views/lancamentoBancario/relatorios/lancamentoBancarioPorPlanoConta";
import TaxaImpostoPageController from "./views/taxaImposto/taxaImpostoPageController";
import LancamentoBancarioPageController from "./views/lancamentoBancario/lancamentoBancarioPageController";
import PerfilTaxaImpostoPageController from "./views/perfilTaxaImposto/perfilTaxaImpostoPageController";
// import ContaRecorrentePageController from "./views/contaRecorrente/contaRecorrentePageController";
import AuditoriaContaFinanceiraPageController from "./views/auditoriaContaFinanceira/auditoriaContaFinanceiroPageController";

const { Title } = Typography;

const PrivateRouteTemplateLogin = ({ children }: any) => {
  const persistedState = useAppSelector((state) => state.persisted);
  return Object.values(persistedState.user).length !== 0 ? <MainTemplate>{children}</MainTemplate> : <Navigate to="/" />;
};

const RouteComponent = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<AcessoPageController />} />
      <Route
        path="/painelGeral"
        element={
          <PrivateRouteTemplateLogin>
            <PainelGeral />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/usuario"
        element={
          <PrivateRouteTemplateLogin>
            <Usuario />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/contaBanco"
        element={
          <PrivateRouteTemplateLogin>
            <ContaBanco />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/banco"
        element={
          <PrivateRouteTemplateLogin>
            <Banco />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/empresa"
        element={
          <PrivateRouteTemplateLogin>
            <EmpresaPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/feriado"
        element={
          <PrivateRouteTemplateLogin>
            <Feriado />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/pessoa"
        element={
          <PrivateRouteTemplateLogin>
            <PessoaPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/gradePremiacao"
        element={
          <PrivateRouteTemplateLogin>
            <GradePremiacao />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/condicaoGeralSorteio"
        element={
          <PrivateRouteTemplateLogin>
            <CondicaoGeralSorteio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/sorteio"
        element={
          <PrivateRouteTemplateLogin>
            <SorteioPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/tipoSorteio"
        element={
          <PrivateRouteTemplateLogin>
            <TipoSorteio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/contaPagar"
        element={
          <PrivateRouteTemplateLogin>
            <ContaFinanceiraPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/contaFinanceiraContabilidade"
        element={
          <PrivateRouteTemplateLogin>
            <ContaFinanceiraPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/contaFinanceiraGuia"
        element={
          <PrivateRouteTemplateLogin>
            <ContaFinanceiraPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/contaReceber"
        element={
          <PrivateRouteTemplateLogin>
            <ContaFinanceiraPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/grupoPlanoContaFinanceiro"
        element={
          <PrivateRouteTemplateLogin>
            <GrupoPlanoContaFinanceiro />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/centroCusto"
        element={
          <PrivateRouteTemplateLogin>
            <CentroCusto />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/consignatario"
        element={
          <PrivateRouteTemplateLogin>
            <ConsignatarioPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/rateioCentroCusto"
        element={
          <PrivateRouteTemplateLogin>
            <RateioCentroCustoPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/formaPagamentoRecebimento"
        element={
          <PrivateRouteTemplateLogin>
            <FormaPagamentoRecebimento />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/planoContaFinanceiro"
        element={
          <PrivateRouteTemplateLogin>
            <PlanoContaFinanceiro />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/grupoPlanoContaFinanceiro"
        element={
          <PrivateRouteTemplateLogin>
            <GrupoPlanoContaFinanceiro />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/planoContaContabil"
        element={
          <PrivateRouteTemplateLogin>
            <PlanoContaContabil />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioMovimentacaoFinanceira"
        element={
          <PrivateRouteTemplateLogin>
            <MovimentacaoFinanceiraRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioContaRecebimento"
        element={
          <PrivateRouteTemplateLogin>
            <ContaPagamentoRecebimentoRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioContaPagamento"
        element={
          <PrivateRouteTemplateLogin>
            <ContaPagamentoRecebimentoRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioContaBancaria"
        element={
          <PrivateRouteTemplateLogin>
            <ContaBancariaRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioSaldoConsignatario"
        element={
          <PrivateRouteTemplateLogin>
            <SaldoConsignatarioRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioCreditosConsignatario"
        element={
          <PrivateRouteTemplateLogin>
            <CreditosConsignatariosRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioLancamentos"
        element={
          <PrivateRouteTemplateLogin>
            <LancamentosRelatorio />
          </PrivateRouteTemplateLogin>
        }
      />
      {/* <Route
        path="/contaRecorrente"
        element={
          <PrivateRouteTemplateLogin>
            <ContaRecorrentePageController />
          </PrivateRouteTemplateLogin>
        }
      /> */}
      <Route
        path="/impostosTaxas"
        element={
          <PrivateRouteTemplateLogin>
            <TaxaImpostoPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/tipoTaxaImposto"
        element={
          <PrivateRouteTemplateLogin>
            <TipoTaxaImposto />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/configuracaoImpostoAdicional"
        element={
          <PrivateRouteTemplateLogin>
            <ConfiguracaoImpostoAdicional />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/perfilTaxaImposto"
        element={
          <PrivateRouteTemplateLogin>
            <PerfilTaxaImpostoPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/fechamentoFinanceiro"
        element={
          <PrivateRouteTemplateLogin>
            <FechamentoFinanceiro />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/agendaCompromissoFiscal"
        element={
          <PrivateRouteTemplateLogin>
            <AgendaCompromissoFiscal />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/agendaCompromissoFiscal"
        element={
          <PrivateRouteTemplateLogin>
            <AgendaCompromissoFiscal />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/lancamentoFinanceiro"
        element={
          <PrivateRouteTemplateLogin>
            <LancamentoBancarioPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/importacaoVendaConsignatario"
        element={
          <PrivateRouteTemplateLogin>
            <ImportacaoVendaConsignatario />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/controleAporte"
        element={
          <PrivateRouteTemplateLogin>
            <LancamentoControleAporte />
          </PrivateRouteTemplateLogin>
        }
      />

      <Route
        path="/comparativoResultadoEmpresa"
        element={
          <PrivateRouteTemplateLogin>
            <ComparativoResultadoEmpresa />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/auditoria"
        element={
          <PrivateRouteTemplateLogin>
            <AuditoriaContaFinanceiraPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/resultadoSorteio"
        element={
          <PrivateRouteTemplateLogin>
            <ResultadoSorteio />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/prestacaoConta"
        element={
          <PrivateRouteTemplateLogin>
            <PrestacaoConta />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/configuracoesPonto"
        element={
          <PrivateRouteTemplateLogin>
            <ConfiguracoesPontoPageController />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/controleComprovanteConsignatario"
        element={
          <PrivateRouteTemplateLogin>
            <PrestacaoConta />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/comparativoEmpresa"
        element={
          <PrivateRouteTemplateLogin>
            <ComparativoEmpresa />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/tipoDocumento"
        element={
          <PrivateRouteTemplateLogin>
            <TipoDocumento />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/composicao"
        element={
          <PrivateRouteTemplateLogin>
            <Composicao />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/parametrizacaoPontoEquilibrio"
        element={
          <PrivateRouteTemplateLogin>
            <PlanoContaFinanceiroResultado />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/lancamentoConsignatario"
        element={
          <PrivateRouteTemplateLogin>
            <LancamentoConsignatario />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/cadastrarContaFinanceira/:tipo"
        element={
          <PrivateRouteTemplateLogin>
            <CadastroEdicaoConta />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/pagamentoRecebimento"
        element={
          <PrivateRouteTemplateLogin>
            <PagamentoPage />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/notasFiscais"
        element={
          <PrivateRouteTemplateLogin>
            <NotasFiscais />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/categoriaEmpresa"
        element={
          <PrivateRouteTemplateLogin>
            <CategoriaEmpresa />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/configuracaoImportacaoVenda"
        element={
          <PrivateRouteTemplateLogin>
            <ConfiguracaoImportacaoVenda />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/anexos"
        element={
          <PrivateRouteTemplateLogin>
            <Anexos />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/grupoContaBanco"
        element={
          <PrivateRouteTemplateLogin>
            <GrupoContaBanco />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route
        path="/relatorioConsolidadoSaldoBancario"
        element={
          <PrivateRouteTemplateLogin>
            <ConsolidadoSaldoBancario />
          </PrivateRouteTemplateLogin>
        }
      />
      <Route path="/relatorioLancamento" element={<LancamentoBancarioRelatorio />} />
      <Route path="/relatorioLancamentoBancario" element={<LancamentoBancarioPorPlanoContaRelatorio />} />
      <Route path="/relatorioEntreEmpresas" element={<RelatorioComparativoEntreEmpresa />} />
      <Route
        path="*"
        element={
          <Flex style={{ paddingLeft: 24 }} vertical>
            <Title level={2} style={{ color: "#334155", fontFamily: "Inter, sans-serif" }}>
              A página que deseja acessar, não existe!
            </Title>
          </Flex>
        }
      />
    </Routes>
  </BrowserRouter>
);

export default RouteComponent;
